import { Injector, Pipe, PipeTransform } from '@angular/core';
import ColorCodingService from '@app/services/color-coding.service';
import { nullable } from '@shared/common/common-types';
import { isNil } from 'lodash';

@Pipe({
    name: 'projectStatusClass',
    standalone: true,
})
class ProjectStatusClassPipe implements PipeTransform {

    colorCodingService: ColorCodingService;

    constructor(injector: Injector) {
        this.colorCodingService = injector.get(ColorCodingService);
    }

    transform(projectStatusName?: nullable<string>): string {
        if (isNil(projectStatusName)) {
            return '';
        }

        return this.colorCodingService.getProjectStatusClassByName(projectStatusName);
    }
}

export default ProjectStatusClassPipe;
